/** JSON 原始值。 */
export type JsonPrimitive = boolean | number | string | null

/** 后端 JSONField 与第三方 JSON 响应允许的对象结构。 */
export interface JsonObject {
  [key: string]: JsonValue
}

/** 可被 JSON 无损表达的值。 */
export type JsonValue = JsonPrimitive | JsonObject | JsonValue[]

/** 判断外部值是否为可安全按键读取的普通对象。 */
export const isUnknownRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)

/** 递归校验外部值是否为合法 JSON 值。 */
export const isJsonValue = (value: unknown): value is JsonValue => {
  if (value === null || typeof value === 'string' || typeof value === 'boolean') return true
  if (typeof value === 'number') return Number.isFinite(value)
  if (Array.isArray(value)) return value.every(isJsonValue)
  if (!isUnknownRecord(value)) return false

  return Object.values(value).every(isJsonValue)
}

/** 校验外部值是否为 JSON 对象。 */
export const isJsonObject = (value: unknown): value is JsonObject =>
  isUnknownRecord(value) && Object.values(value).every(isJsonValue)
